import { RootState } from '../store/store';

export const userAuth = (state: RootState) => state.auth.isAuth;
export const modalIsOpened = (state: RootState) => state.modal.isOpened;
export const modalType = (state: RootState) => state.modal.type;
export const modalExtra = (state: RootState) => state.modal.extra;
export const getIsOffcanvasOpened = (state: RootState) => state.offcanvas.isOpened;
export const getOffcanvasType = (state: RootState) => state.offcanvas.type;
export const getOffcanvasExtra = (state: RootState) => state.offcanvas.extra;
export const getTheme = (state: RootState) => state.themes.theme;
export const getUserInfo = (state: RootState) => state.user.user;
export const getUserRole = (state: RootState) => state.user.user?.role;
/**
 * Role gates read `role` (`ROLE_SUPER_ADMIN` / `ROLE_ADMIN` / `ROLE_USER`), never `roleName` —
 * the latter is the localised label out of `UserRole.getName()` in apisupport.
 *
 * Everything under `/consumers/settings` and `/consumers/languages` in apisupport is gated on
 * `getOrdinalRole() > 0`, so an admin gets a 403 on every write there.
 */
export const getIsSuperAdmin = (state: RootState) => state.user.user?.role === 'ROLE_SUPER_ADMIN';
/**
 * Everything a plain user must not reach — logs, exports, transactions — is gated on
 * `getOrdinalRole() > 1` in apisupport, i.e. admin and superadmin.
 */
export const getIsAtLeastAdmin = (state: RootState) =>
  state.user.user?.role === 'ROLE_SUPER_ADMIN' || state.user.user?.role === 'ROLE_ADMIN';
export const getAllLogsTypes = (state: RootState) => state.logsTypes.types;
export const getConsumersSearch = (state: RootState) => state.search.consumers;
export const getActualMessageChannel = (state: RootState) => state.messageChannel;
export const getInvoicesFilters = (state: RootState) => state.invoicesFilters;
export const getConsumerFilters = (state: RootState) => state.consumerFilters.filter;
export const getTariffInfo = (state: RootState) => state.tariff;
export const getUnreadCountChannel = (state: RootState) => state.unreadChannels.unreadChannels;
export const getLogsFilters = (state: RootState) => state.logsFilter;
